/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { ContentImportRun, ContentImportSource, ContentImportTarget } from "./data-contracts";

/**
 * No description
 * @tags imports
 * @name StartImportRun
 * @summary Import content into a space from a website
 * @request POST:/org/{organizationId}/imports
 * @secure
 */

// @ts-ignore
export const startImportRun: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {};
  RequestBody: {
    source: ContentImportSource;
    target: ContentImportTarget;
    /**
     * Enhance the imported content with AI
     * @default true
     */
    enhance?: boolean;
  };
  RequestHeaders: {};
  ResponseBody: ContentImportRun;
  ResponseStatusCode: 201 | 400 | 404;
} = {
  route: "/org/{organizationId}/imports",
  method: "post",
  streaming: false,
  tags: ["imports"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags imports
 * @name CancelImportRun
 * @summary Cancel an import run
 * @request POST:/org/{organizationId}/imports/{importRunId}/cancel
 * @secure
 */

// @ts-ignore
export const cancelImportRun: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the import run */
    importRunId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: ContentImportRun;
  ResponseStatusCode: 201 | 400 | 404;
} = {
  route: "/org/{organizationId}/imports/{importRunId}/cancel",
  method: "post",
  streaming: false,
  tags: ["imports"],
  criticalityLevel: "low",
  deprecated: false,
};
